import { setupAxiosAuth } from "./utils/adminAuth";

setupAxiosAuth();
